<template>
  <div id="home">
    <my-header></my-header>
    <div class="pd20">
      <h3 class="mt0">{{'Manage invitation'|translate}}</h3>

      <p
        class="mt20 alert alert-info"
        v-if="list_items && list_items.length == 0"
      >{{'There is no data'|translate}}</p>
      <table class="table mt10" v-if="list_items && list_items.length > 0">
        <thead>
          <tr>
            <th>{{'Object'|translate}}</th>
            <th>{{'Mesage'|translate}}</th>
            <th>{{'Action'|translate}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item) in list_items" :key="item.id">
            <td>{{item.object|translate}}</td>

            <td>{{ item.message }}</td>

            <td>
              <a
                class="btn btn-success"
                v-on:click="remove(item,true)"
                :disabled="removing"
              >{{'Accept'|translate}}</a>
              <a
                class="btn btn-danger"
                v-on:click="remove(item,false)"
                :disabled="removing"
              >{{'Decline'|translate}}</a>
            </td>
          </tr>
        </tbody>
      </table>
      <paginate
        v-if="total_page > 1"
        :page-count="total_page"
        :click-handler="clickPage"
        :prev-text="'Prev'|translate"
        :next-text="'Next'|translate"
        v-model="page"
        :container-class="'pagination'"
      ></paginate>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/elements/Loading";

import Utils from "@/helpers/utils";
import MyHeader from "@/components/Layout/Header";
import { EventBus } from "@/helpers/event-bus";

//import GoogleAutocomplete from 'google-autocomplete-vue';
export default {
  name: "Invitation",
  components: {
    Loading,
    MyHeader
  },
  computed: {
    authHeaders() {
      return Utils.getHeader(this);
    }
  },
  data() {
    return {
      ready: false,
      working: false,
      removing: false,

      keyword: "",
      total_page: 1,
      limit: Utils.getLimit(),
      list_items: null,
      src_image: "/static/images/no-photo.jpg"
    };
  },
  created() {
    // clone from original params
  },
  methods: {
    remove(item, is_accept = true) {
      let message;
      if (!is_accept) {
        message = "Are you sure to decline this item ?";
      } else {
        message = "Are you sure to agree this item ?";
      }
      this.$alertify.confirmWithTitle(
        this.$t("Confirm"),
        this.$t(message),
        () => {
          this.removing = true;
          Utils.request(this, true, "invitation")
            .delete(`/manage/${item.id}?accept=${is_accept ? 1 : 0}`)
            .then(response => {
              this.removing = false;
              let data = response.data;
              if (data.status === "ok") {
                this.offset = 0;
                this.list();
                EventBus.$emit("updateUser", this.user);
              } else {
                Utils.showError(this, data.data);
              }
            });
        }
      );
    },
    list() {
      let wating = [];

      let data = {
        offset: 0,
        limit: this.limit
      };
      wating.push(
        Utils.request(this, true, "invitation").get(
          `/manage/?${Utils.arrayToRequestParam(data)}`
        )
      );

      Promise.all(wating).then(values => {
        this.list_items = values[0].data.data.list;
      });
    }
  },
  mounted() {
    this.list();
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Page/Invitation.vue